<ng-template [ngIf]="dettaglioForm">
    <div class="col-sm-12 coldx">
        <h4 *ngIf="title">{{title}}</h4>
        <form [formGroup]="dettaglioForm" (ngSubmit)="update();">
            <div class="row">
                <div comboModInput [control]="dettaglioForm.controls['tipoEsito']" class="col-sm-4 obbligatorio"
                    [labelInput]="'Tipo provvedimento'" formControlName="tipoEsito" [mandatory]="true"
                    [objectReference]="request.tipoEsito" (onReturn)="request.tipoEsito = $event;"
                    [optionsCombo]="tipoEsitiOptions" [ngModel]="request.tipoEsito"></div>
    
                <div textInput [control]="dettaglioForm.controls['esitoDescrizione']" class="col-sm-8"
                    [labelInput]="'Esito'"formControlName="esitoDescrizione" [mandatory]="true"  [(ngModel)]="request.esitoDescrizione"></div>    
            </div>
            <div class="row">   
                <div textInput [control]="dettaglioForm.controls['numeroEsito']" [mandatory]="false" class="col-sm-4"
                    [labelInput]="'Numero esito'" formControlName="numeroEsito" [(ngModel)]="request.numeroEsito"></div>
    
                <div naturalNumberInput [control]="dettaglioForm.controls['annoEsito']" class="col-sm-4"
                    [labelInput]="'Anno esito'" [maxLength]="'4'" formControlName="annoEsito"
                    [(ngModel)]="request.annoEsito" [mandatory]="false" [checkFormat]="true"></div>

                <div datePickerInput class="col-sm-4" [labelInput]="'Data pubblicazione'" 
                    formControlName="dataPubblicazione" [(ngModel)]="request.dataPubblicazione" [mandatory]="true"></div>       
            </div>
            <div class="row">
                <p class="mandatory col-sm-12">
                    <em>* Campi obbligatori</em>
                </p>
            </div>
            <div class="row">
                <p class="col-sm-3 col-xs-6">
                    <button type="button" class="btn btn-outline-secondary btn-block"
                        (click)="createForm();">Reset</button>
                </p>
                <p submitButton [disabled]="!dettaglioForm.valid"
                    class="col-sm-3 col-xs-6 col-sm-offset-6" [labelButton]="'Salva'"></p>
            </div>
        </form>
    </div>
</ng-template>